import { JsonObject } from 'json2typescript';
import { SheduledReportsInterface } from '../interfaces/sheduled-reports.interface';
import { SheduledReportsGenerateModel } from './scheduledreportsgenerated.model';

@JsonObject('SheduledReportsModel')
export class SheduledReportsModel implements SheduledReportsInterface {
  Frecuency?: string;
  Name?: string;
  PortfolioCode?: string;
  PortfolioCodeView?: string;
  Scheduledreportsgenerated?: SheduledReportsGenerateModel[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
